/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
  GetApiV1PersonSharedBusinessSectorDropdown401,
  GetApiV1PersonSharedBusinessSectorDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedBusinessSectorDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedBusinessSectorDropdown } from "../../clients/personSharedController/getApiV1PersonSharedBusinessSectorDropdown.ts";

export const getApiV1PersonSharedBusinessSectorDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/business-sector-dropdown" }] as const;

export type GetApiV1PersonSharedBusinessSectorDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedBusinessSectorDropdownQueryKey
>;

export function getApiV1PersonSharedBusinessSectorDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedBusinessSectorDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedBusinessSectorDropdown401
      | GetApiV1PersonSharedBusinessSectorDropdown500
    >,
    GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedBusinessSectorDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os setores de negócio cadastrados, com nome resolvido pelo idioma configurado, ordenados por ID. **(Requer Authorization para autenticação)**
 * @summary Lista de setores de negócio para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/business-sector-dropdown}
 */
export function useGetApiV1PersonSharedBusinessSectorDropdown<
  TData = GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedBusinessSectorDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedBusinessSectorDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedBusinessSectorDropdown401
          | GetApiV1PersonSharedBusinessSectorDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedBusinessSectorDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedBusinessSectorDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedBusinessSectorDropdown401
      | GetApiV1PersonSharedBusinessSectorDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
